import { render } from "./Welcome.vue?vue&type=template&id=7e88f262"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=7e88f262&lang=scss"
script.render = render

export default script